import { assertNever } from 'owa-assert';
import type { TimeStreamProject } from '../schema';
import getStore from '../store';

export default function getSelectedProject(): TimeStreamProject {
    const { selectedProjectId, projects } = getStore();
    if (!selectedProjectId) {
        assertNever('no selectedProject' as never);
    }

    const selectedProject = projects.get(selectedProjectId);
    if (!selectedProject) {
        assertNever(`Project ${selectedProjectId} is not available` as never);
    }

    return selectedProject;
}
